module.exports = __webpack_public_path__ + "img/engineering-min.07c78bea.jpg";